<template>
  <b-container>
    <b-row>
      <b-col md="12">
        <article class="post-area single-blog">
          <b-row>
            <b-col md="12">
              <h2>Urejanje vsebin</h2>
            </b-col>
          </b-row>

          <b-row>
            <loading
              :active.sync="isLoading"
              :color="'#408521'"
              :is-full-page="false"
            ></loading>

            <b-col md="12" style="min-height: 400px">
              <h5 class="mt-3">Stran VSA - "O akciji"</h5>
              <hr />

              <!-- Banner image -->
              <b-form-group label="Banner slika" class="mt-4">
                <div v-if="bannerPreview || bannerUrl" class="mb-3">
                  <img
                    :src="bannerPreview || bannerUrl"
                    alt="Banner preview"
                    style="max-width: 100%; max-height: 200px; object-fit: contain;"
                  />
                  <br />
                  <b-button
                    variant="link"
                    size="sm"
                    class="text-danger pl-0 mt-1"
                    @click="clearBanner"
                  >
                    <i class="fa fa-times"></i> Odstrani sliko
                  </b-button>
                </div>
                <b-form-file
                  v-if="!bannerPreview && !bannerUrl"
                  v-model="bannerFile"
                  accept="image/*"
                  placeholder="Izberi banner sliko..."
                  @change="previewBanner"
                ></b-form-file>
              </b-form-group>

              <hr />

              <!-- Rich text editor -->
              <b-form-group label="Vsebina zavihka 'O akciji'" class="mt-4">
                <div>
                  <a
                    class="btn btn-link editCode p-3 pl-0"
                    @click="showSource = !showSource"
                  >{{ showSource ? "Skrij izvorno kodo" : "Pokaži izvorno kodo" }}</a>
                  <b-textarea
                    rows="20"
                    v-if="showSource"
                    v-model="oAkcijiContent"
                    style="overflow-y: auto;"
                  ></b-textarea>
                </div>
                <vue-editor
                  v-if="!showSource"
                  id="oAkcijiContent"
                  v-model="oAkcijiContent"
                  :editor-toolbar="customToolbar"
                ></vue-editor>
              </b-form-group>

              <!-- Save button -->
              <b-button
                variant="success"
                class="mt-3 mb-4"
                @click="save"
                :disabled="isLoading"
              >
                <i class="fa fa-save mr-1"></i>
                Shrani
              </b-button>
            </b-col>
          </b-row>
        </article>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { db } from "@/main";
import firebase from "firebase";
import Loading from "vue-loading-overlay";

export default {
  name: "ContentEditor",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      showSource: false,
      oAkcijiContent: "",
      bannerUrl: "",
      bannerFile: null,
      bannerPreview: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "video"],
        [{ header: [1, 2, 3, false] }]
      ]
    };
  },
  async mounted() {
    await this.loadContent();
  },
  methods: {
    async loadContent() {
      const _this = this;
      _this.isLoading = true;

      try {
        const doc = await db.collection("page_content").doc("vsa").get();
        if (doc.exists) {
          const data = doc.data();
          _this.oAkcijiContent = data.oAkcijiContent || "";
          _this.bannerUrl = data.bannerUrl || "";
        }
      } catch (error) {
        console.error("Error loading content:", error);
      }

      _this.isLoading = false;
    },

    previewBanner(event) {
      const file = event.target.files[0];
      if (file) {
        this.bannerPreview = URL.createObjectURL(file);
        this.bannerFile = file;
      }
    },

    clearBanner() {
      this.bannerFile = null;
      this.bannerPreview = null;
      this.bannerUrl = "";
    },

    async uploadBanner(file) {
      const storageRef = firebase
        .storage()
        .ref("vsa")
        .child("banner");

      const snapshot = await storageRef.put(file);
      return await snapshot.ref.getDownloadURL();
    },

    async save() {
      const _this = this;
      _this.isLoading = true;

      try {
        let bannerUrl = _this.bannerUrl;

        if (_this.bannerFile) {
          bannerUrl = await _this.uploadBanner(_this.bannerFile);
          _this.bannerUrl = bannerUrl;
          _this.bannerFile = null;
          _this.bannerPreview = null;
        }

        await db.collection("page_content").doc("vsa").set({
          oAkcijiContent: _this.oAkcijiContent,
          bannerUrl: bannerUrl,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        });

        _this.$swal("Vsebina shranjena!", "", "success");
      } catch (error) {
        console.error("Error saving content:", error);
        _this.$swal("Napaka pri shranjevanju!", error.message, "error");
      }

      _this.isLoading = false;
    }
  }
};
</script>
